import { FC, useMemo } from "react"

// components
import Topic from "./Topic"

// styles
import {
  topicSection,
  topicSectionHeader,
  topicSectionButtons
} from "../BrowseByTopicSection/Topic.module.scss"

type HelpCenterHomePage = NonNullable<
  Queries.HomepageDataQuery["helpCenterHomePage"]
>

type AudienceContentItem =
  | NonNullable<NonNullable<HelpCenterHomePage["attendee"]>["content"]>[number]
  | NonNullable<NonNullable<HelpCenterHomePage["organizer"]>["content"]>[number]

export type Props = {
  content: AudienceContentItem
  prefixedBasePath: string
}

const TopicSection: FC<Props> = ({ content, prefixedBasePath }) => {
  const topics = useMemo(() => {
    if (content && "attendeeCategories" in content) {
      return content?.attendeeCategories
    } else if (content && "organizerCategories" in content) {
      return content?.organizerCategories
    }
  }, [content])

  if (
    content &&
    ("attendeeCategories" in content || "organizerCategories" in content)
  ) {
    return (
      <div className={topicSection}>
        <h2 className={topicSectionHeader}>{content?.title}</h2>
        <div className={topicSectionButtons}>
          {topics?.map((topic) => {
            if (!topic) return null
            return (
              <Topic
                key={topic.title}
                topic={topic}
                prefixedBasePath={prefixedBasePath}
              />
            )
          })}
        </div>
      </div>
    )
  }

  return null
}

export default TopicSection
